import { Domain } from 'src/app/services/domain.service';

/**
 * La messagerie n'est proposée (onglet du pied de page, « Nous écrire » sous
 * les FAQ et articles, « Contactez-nous ! » dans la recherche, lien dans les
 * réponses de l'assistant) que si le module est activé et qu'au moins un
 * destinataire existe : l'équipe Maviepro, l'adresse générique du CSE ou un
 * élu autorisé à répondre. La page « Nouveau message » propose ces mêmes
 * destinataires, dans le même ordre de priorité.
 */
export const canUseMessaging = (domain: Domain | null | undefined): boolean => {
  const chat = domain?.chat;
  if (!chat?.is_activated) {
    return false;
  }

  const mavieproTeamReachable = chat.is_maviepro_contact_activated !== false;
  const cseEmail = domain.contact?.email;
  const cseReachable = typeof cseEmail === 'string' && cseEmail.trim().length > 0;
  // Absent d'une réponse d'API antérieure : on suppose qu'un élu est joignable,
  // comme avant l'introduction du drapeau.
  const electedMemberReachable = chat.has_interlocutors !== false;

  return mavieproTeamReachable || cseReachable || electedMemberReachable;
};
